export default __webpack_public_path__ + "static/media/p2.6682af53.jpg";